import { createReducer, RequestStatus } from '@lib/plugin-redux-core';
import { FormEditPageInitialState } from './form-edit.states';
import { commonFormHandlers } from './form-edit.handlers';
import { tabInfoHandlers } from './tab-info';
import { tabAssignmentHandlers } from './tab-assignment';
import { tabQuestionsHandlers } from './tab-questions';
import { formHeaderHandlers } from './header';
import { selectFormModalHandlers } from './select-form-modal';

export const initialState: FormEditPageInitialState = {
  error: null,
  questions: [],
  sections: [],
  headings: [],
  imagesInQuestion: [],
  isQuestionEditing: false,
  // File
  selectedFile: null,
  isFormHasQuestions: null,
  hasEssayOrFillInBlankQuestion: false,
  draftQuestions: {},
  aiChanges: [],
  mentionResources: [],
  aiAcceptQuestionChangeStatus: RequestStatus.RESET,
  aiAcceptSectionChangeStatus: RequestStatus.RESET,
  aiAcceptHeadingChangeStatus: RequestStatus.RESET,
  aiAcceptAllChangeStatus: RequestStatus.RESET,
  importFormStatus: RequestStatus.RESET,
  acceptingQuestionId: null,
  acceptingSectionId: null,
  acceptingHeadingId: null,
  aiProcessing: false,
  hasAiChanges: false,
  formTotalQuestions: 0,
  formTotalScore: 0,
  getAiChangeResourcesStatus: RequestStatus.RESET,
  // Select Form Modal
  globalForms: [],
  globalFormsNextToken: null,
  localForms: [],
  localFormsNextToken: null,
  localFolderNextToken: null,
  globalFormsSearchResult: [],
  globalFormsSearchNextToken: null,
  localFormsSearchResult: [],
  localFormsSearchNextToken: null,
  localFolderSearchNextToken: null,
  getGlobalFormsStatus: RequestStatus.RESET,
  getLocalFormsStatus: RequestStatus.RESET,
  searchGlobalFormsStatus: RequestStatus.RESET,
  searchLocalFormsStatus: RequestStatus.RESET,
  selectFormPendingGlobalMode: null,
  selectFormPendingLocalMode: null,
  selectFormPendingGlobalIsSearch: false,
  selectFormPendingLocalIsSearch: false,
};

export const formEditReducer = createReducer(initialState, [
  ...commonFormHandlers,
  ...formHeaderHandlers,
  ...tabQuestionsHandlers,
  ...tabInfoHandlers,
  ...tabAssignmentHandlers,
  ...selectFormModalHandlers,
]);
